import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy, inject } from '@angular/core';
import {AuthenticationService} from "../../services/auth.service";
import {ApiService} from "../../services/api.service";
import {NavigationBarItem} from "../../interfaces/navigation";
import { RouterLink } from '@angular/router';

@Component({
    selector: 'kaz-menu',
    templateUrl: './kaz-menu.component.html',
    styleUrls: ['./kaz-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink]
})
export class KazMenuComponent implements OnInit{
  _auth = inject(AuthenticationService);
  private _api = inject(ApiService);

  @Output() closeMenu = new EventEmitter<boolean>
  mail: string | undefined = undefined;

 ngOnInit() {
    this.mail = this._auth.getClaimsFromToken()?.mail;
 }

  logout() {
    this._auth.clearAuth();
  }

  onCloseMenuClick() {
    this.closeMenu.emit();
  }

  protected readonly NavigationBarItem = NavigationBarItem;
}
